import { useOktaAuth } from "@okta/okta-react";

async function requestData<T>(
    method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH',
    url: string,
    accessToken: string,
    payload?: unknown
): Promise<any> {
    const apiUrl = process.env.REACT_APP_NL_API_ENDPOINT || '';
    const finalUrl = `${apiUrl}${url}`;

    const response = await fetch(finalUrl, {
        method,
        headers: {
            'Content-Type': 'application/json',
            Authorization: accessToken,
        },
        body: payload ? JSON.stringify(payload) : undefined,
    });

    if (!response.ok) {
        const errorBody = await response.json().catch(() => null);

        throw {
            status: 'error',
            error:
                {
                    code: 'FETCH_ERROR',
                    message: errorBody?.detail?.[0]?.msg ||
                    `Request failed with status ${response.status}`
                },
            response: errorBody,
        };
    }

    if (response.status === 204) {
        return {} as T;
    }
    const data = await response.json() as T;

    return {
        response: data,
        status: "successful",
        error: ""
    };

}

export const fetchData = <T>(
    url: string,
    accessToken: string
) => requestData<T>('GET', url, accessToken);

